import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./glowingText.module.css";
const GlowingText = ({ children }) => {
    return _jsx("div", { className: styles.glowingText, children: children });
};
export default GlowingText;
